// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"I8-z"};